import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
    title: {
        id: '_.funding_requirements.all_requirements_completed_title',
        defaultMessage: 'Looks like you’ve completed all steps!'
    },
    caption: {
        id: '_.funding_requirements.all_requirements_completed_caption',
        defaultMessage:
            'Click ‘{next}’ to go to confirm your drawdown. {br} We won’t send the funds to you until you hit ‘Confirm’ on the next step.'
    },
    interestOnlyCaption: {
        id: '_.funding_requirements.all_requirements_completed_interestOnlyCaption_caption',
        defaultMessage:
            'Click ‘{next}’ to extend your loan. {br} The loan will not be extended until you click ‘Confirm‘ in the next step.'
    },
    action: {
        id: '_.funding_requirements.all_requirements_completed_action',
        defaultMessage: 'Next'
    }
});
